// Paths to the existing admin detail pages for the various entity kinds the
// content-moderation event references. Kept here (not inlined at call sites)
// so a future route rename is a single-file change. Internal-app routes — we
// open them in a new tab via target="_blank" so the reviewer doesn't lose
// their place in the review screen.

export type LinkableEntityKind =
  | 'fundraiser'
  | 'team'
  | 'collection'
  | 'account'
  | 'organization';

export function entityDetailUrl(kind: LinkableEntityKind, id: number): string {
  switch (kind) {
    case 'fundraiser':
      return `/fundraisers/view/${id}`;
    case 'team':
      return `/fundraisers/team/view/${id}`;
    case 'collection':
      return `/fundraisers/collection/view/${id}`;
    case 'account':
      return `/accounts/detail/${id}`;
    case 'organization':
      return `/organization/${id}/backoffice`;
  }
}
